import Storage from './Storage';
import { OPENED_SIDEBAR } from './menuSidebarSlice';

export const toggleOpenedSidebar = openedSidebar => dispatch => {
  Storage.setItem('openedSidebar', openedSidebar);
  dispatch(OPENED_SIDEBAR({ openedSidebar }));
};
